import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { branchShape } from '@bibliocommons/bc-prop-types';

import HoldsPickupBranchSelect from '../HoldsPickupBranchSelect';
import HoldsExpiryDate from '../HoldsExpiryDate';
import HoldsPauseDateLink from '../HoldsPauseDateLink';
import HoldStatusIcon from '../HoldStatusIcon';
import HoldPosition from '../../HoldPosition';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';

import './HoldsSecondaryInfo.scss';

export default class HoldsSecondaryInfo extends BcReactComponent {
  renderHoldsStatus() {
    const { item } = this.props;
    const statusClass = item.get('status') ? item.get('status').toLowerCase() : '';

    return (
      <div className={cn('holds-status', statusClass)}>
        <HoldStatusIcon
          status={item.get('status')}
          withBackground
          withLabel />
        <HoldPosition
          status={item.get('status')}
          position={item.get('holdsPosition')}
          totalCopies={item.getIn(['bib', 'availability', 'totalCopies'], 0)}
          holdText={item.get('holdText')} />
      </div>
    );
  }

  renderPauseDate() {
    const { item, holdsTransactions, handleUpdatePauseEndDate, actionInProgress } = this.props;
    let pauseDataStatus = null;

    const isLoading = holdsTransactions.getIn([item.get('holdsId'), 'isUpdatingPauseDate'], false);
    if (item.get('suspendEndDate') && item.get('status') === 'SUSPENDED') {
      pauseDataStatus = (<FormattedMessage
        key="holds-pause-date"
        tagName="div"
        id="paused_until_date"
        values={{
          date: (
            <HoldsPauseDateLink
              disabled={actionInProgress && !isLoading}
              item={item}
              isLoading={isLoading}
              handleUpdatePauseEndDate={handleUpdatePauseEndDate} />
          )
        }} />);
    } else if (item.get('suspendEndDate') && item.get('suspendStartDate')) {
      pauseDataStatus = (<FormattedMessage
        key="holds-pause-date"
        tagName="div"
        id="paused_from"
        values={{
          date: <ShortFormattedDate value={item.get('suspendStartDate')} />
        }} />);
    }

    return pauseDataStatus;
  }

  renderPickupDate() {
    const { item } = this.props;
    const isReadyForPickup = item.get('status') === 'READY_FOR_PICKUP';
    const pickupByDate = item.get('pickupByDate');

    return isReadyForPickup && pickupByDate && (
      <FormattedMessage
        key="holds-pickup-date"
        id="pick_up_by_date"
        values={{ date: <ShortFormattedDate value={pickupByDate} /> }} />
    );
  }

  renderExpiryDate() {
    const { item, holdsTransactions, handleUpdateExpiryDate, actionInProgress } = this.props;
    const status = item.get('status');
    const isLoading = holdsTransactions.getIn([item.get('holdsId'), 'isUpdatingExpiryDate'], false);

    return ((['NOT_YET_AVAILABLE'].includes(status)) && item.get('expiryDate')) && (
      <div className="holds-expiry-date" key="hold-expires-date">
        <FormattedMessage
          id="expires_on_date"
          values={{ date: (
            <HoldsExpiryDate
              disabled={actionInProgress && !isLoading}
              isLoading={isLoading}
              handleUpdateExpiryDate={handleUpdateExpiryDate}
              item={item} />
          ) }} />
      </div>
    );
  }

  renderPickupLocation() {
    const { item, holdsTransactions, branches, handleUpdatePickupBranch, actionInProgress } = this.props;
    const bibType = item.get('materialType');
    const isLoading = holdsTransactions.getIn([item.get('holdsId'), 'isUpdatingPickupLocation'], false);
    return (
      <div key="holds-pickup-branch" className="holds-pickup-branch">
        {
          bibType === 'PHYSICAL' && (
            <HoldsPickupBranchSelect
              handleUpdatePickupBranch={handleUpdatePickupBranch}
              disabled={actionInProgress && !isLoading}
              isLoading={isLoading}
              item={item}
              selected={item.getIn(['pickupLocation', 'code'])}
              branches={branches} />
        )}
      </div>
    );
  }

  render() {
    const { item } = this.props;
    const bibType = item.get('materialType');

    return (
      <div className="cp-holds-secondary-info">
        {this.renderHoldsStatus()}
        {bibType === 'PHYSICAL' && [this.renderPickupLocation(), this.renderExpiryDate(), this.renderPickupDate()] }
        {this.renderPauseDate()}
      </div>
    );
  }
}

HoldsSecondaryInfo.propTypes = {
  actionInProgress: PropTypes.bool,
  item: ImmutablePropTypes.map,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  isPickupLocationEditable: PropTypes.bool,
  holdsTransactions: ImmutablePropTypes.map,
  handleUpdatePickupBranch: PropTypes.func,
  handleUpdatePauseEndDate: PropTypes.func,
  handleUpdateExpiryDate: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsSecondaryInfo/HoldsSecondaryInfo.jsx